import { lazy } from 'react';

// ----------------------------------------------------------------------

const MakersDeduplicationPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "MakersDeduplicationPage" */
      '@/pages/makers/deduplication/MakersDeduplicationPage'
    ),
);

export default MakersDeduplicationPage;
